
import { NgModule, ModuleWithProviders, Injector, APP_INITIALIZER } from '@angular/core';
import { NZ_I18N, en_US, zh_CN, NzI18nModule } from 'ng-zorro-antd/i18n';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MmI18nConfig } from './i18n-config';
import { MmTranslateService } from './translate.service';
import { I18nInterceptor } from './i18n-interceptor';
import { MmTranslateHttpLoader } from './mmTranslateHttpLoader';
import { I18nTextInputComponent } from './components/i18n-text-input/i18n-text-input.component';
import { NzTableModule } from 'ng-zorro-antd/table'
import { TRANSLATION_GROUP_TOKEN } from './tanslatation-group-token';
import { TranslationGroup } from './tanslation-group';
import { en } from './i18n/en';
import { zh } from './i18n/zh';
import { mmI18nConstants } from './i18n-constants';
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input'
import { mmIconTranslationGroup } from '../icon/icon-translation-group';

import { mmMenuTranslationGroup } from '../menu';
import {mmLanguageTranslationGroup} from '../language';
import { mmCodeTableTranslationGroup } from '../code-table/code-table-translation-group';
import { mmAttachmentTranslationGroup } from '../attachment/attachment-translation-group';
import { mmIdentityTranslationGroup } from '../identity/identity-translation-group';
import { MM_I18N_CONFIG_TOKEN } from './i18n-config-token';
import { mmTableTranslationGroup } from '../table/table-translation-group';
import { LocalizePipe } from './localize.pipe';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPopoverModule } from 'ng-zorro-antd/popover'
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { MmTranslatePipe } from './mm-translate.pipe';
import { I18nRequiredMessagePipe } from './i18n-required-message.pipe';
import { mmFormTranslationGroup } from '../form/form-translation-group';
import { LangSwitchComponent } from './lang-switch/lang-switch.component';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { formatTranslationGroup } from './format';
import { mmI18nTranslationGroup } from './i18n';
import { mmHttpTranslationGroup } from '../http';
import { PortalModule } from '@angular/cdk/portal'



export function MmHttpLoaderFactory(injector: Injector) {
    return new MmTranslateHttpLoader(injector);
}
@NgModule({
    imports: [
        TranslateModule,
        NzI18nModule,
        NzIconModule,
        NzTableModule,
        FormsModule,
        CommonModule,
        NzInputModule,
        NzButtonModule,
        NzPopoverModule,
        NzDropDownModule,
        PortalModule,
        NzMenuModule,
        NzPopconfirmModule],
    exports: [TranslateModule, NzI18nModule, I18nTextInputComponent, LocalizePipe, MmTranslatePipe, NzTableModule, LangSwitchComponent],
    declarations: [I18nTextInputComponent, LocalizePipe, MmTranslatePipe, I18nRequiredMessagePipe, LangSwitchComponent],
    providers: [],
})
export class MmI18nModule {
    static forRoot(config: MmI18nConfig = {
        defaultLang: "en",
        supportedLangs: ["en", "zh"]
    }): ModuleWithProviders<any> {
        return {
            ngModule: MmI18nModule,
            providers: [
                ...TranslateModule.forRoot(
                    {
                        defaultLanguage: config.defaultLang,
                        useDefaultLang: true,

                        loader: {
                            provide: TranslateLoader,
                            useFactory: MmHttpLoaderFactory,
                            deps: [Injector]
                        }
                    }
                ).providers,
                {
                    provide: NZ_I18N,
                    useFactory: (translate: TranslateService) => {
                        var lang = translate.currentLang || translate.defaultLang;
                        switch (lang) {
                            case 'en':
                                return en_US;
                            case 'zh':
                                return zh_CN;
                            default:
                                return en_US;
                        }
                    },
                    deps: [TranslateService]
                },
                MmTranslateService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: (s: MmTranslateService) => { return () => s.init() },
                    deps: [MmTranslateService],
                    multi: true
                },
                {
                    provide: MM_I18N_CONFIG_TOKEN,
                    useValue: config,
                    multi: false
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: I18nInterceptor,
                    multi: true
                },

                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: formatTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmI18nTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmIconTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmMenuTranslationGroup,
                    multi: true
                },
              {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmLanguageTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmCodeTableTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmAttachmentTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmHttpTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmIdentityTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmTableTranslationGroup,
                    multi: true
                },
                {
                    provide: TRANSLATION_GROUP_TOKEN,
                    useValue: mmFormTranslationGroup,
                    multi: true
                }
            ]
        }
    }
}
